import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=0a03719a&"
import script from "./ResultsTable.vue?vue&type=script&lang=js&"
export * from "./ResultsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports